import * as yup from 'yup'

const rgeTypeMap = {
  tel: /^1[3456789]\d{9}$/,
  identify: /^\d{17}[0-9Xx]$/,
}
export default function (opts) {
  const {
    required,
    rangeSetting,
    minlen,
    maxlen,
    repeatCheckSet,
    rge,
    rgeType,
  } = opts

  let schema = yup.string().nullable()
  if (required) {
    schema = schema.required('这是一个必填项')
  }
  if (rangeSetting && minlen) {
    schema = schema.min(minlen, `不能少于${minlen}个字符`)
  }
  if (rangeSetting && maxlen) {
    schema = schema.max(maxlen, `不能超过${maxlen}个字符`)
  }
  if (repeatCheckSet) {
    schema = schema.notOneOf(repeatCheckSet, '不能输入重复内容')
  }
  if (rge) {
    schema = schema.matches(rge, '格式不正确')
  }

  if (rgeType && rgeTypeMap[rgeType]) {
    schema = schema.matches(rgeTypeMap[rgeType], '格式不正确')
  }

  return schema
}
